import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-b border-line bg-canvas" data-id="element-40" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-xl px-3 py-6 sm:px-5" data-id="element-41" data-mp="2blngn3eltvsi">
        <h2 id="faq" className="text-center font-display text-base font-extrabold uppercase text-ink sm:text-xl" data-id="element-42" data-mp="2flpibckcap7s">
          Preguntas frecuentes
        </h2>

        <div className="mt-2.5 space-y-1.5" data-id="element-43" data-mp="26tnmjrl7tx3u">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <Reveal key={faq.q} delay={i * 0.015} className="rounded-lg border border-line bg-surface" data-id="element-44" data-mp="2uigab0rooynd" data-mpi={i}>
                <h3 data-id="element-45" data-mp="1vp9gq63u6kh4">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-2.5 px-3 py-2.5 text-left" data-id="element-46" data-mp="1vqsy6018b1kh">
                    <span className="text-[0.82rem] font-semibold leading-snug text-ink" data-id="element-47" data-mp="20n16oukx7wio">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={15} className={`flex-shrink-0 text-cyan transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-48" data-mp="2adm5ai0lh11l" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-49" data-mp="u0xlm6cdsbmc">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-50" data-mp="p2dw5vykwhp8">
                      <p className="px-3 pb-2.5 text-[0.78rem] leading-snug text-ink-muted" data-id="element-51" data-mp="333li2wo0nzad">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}